import React, { useEffect } from "react";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Image, Input, Switch } from "antd";
import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import UploadFoodImage from "../../../lib/UploadFoodImage";
import TextArea from "antd/es/input/TextArea";

interface ExperienceTotalQualityProps {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  data?: {
    heading?: string;
    image?: string[];
    subtext?: string;
  };
  loading?: boolean;
}

const ExperienceTotalQuality: React.FC<ExperienceTotalQualityProps> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  data,
  loading,
}) => {
  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        experience_tqp: {
          heading: data.heading || "",
          subtext: data.subtext || "",
          image: data.image || [],
        },
      });
    } else {
      form.resetFields();
    }
  }, [data, form]);

  return (
    <div>
      {!isEditing ? (
        <>
          <div className="rounded-[20px] overflow-hidden hidden sm:block">
            <table className="min-w-full border-collapse">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left text-sm md:text-base">
                    Image
                  </th>
                  <th className="py-3 px-4 text-center text-sm md:text-base">
                    Heading
                  </th>
                  <th className="py-3 px-4 text-center text-sm md:text-base">
                    Subtext
                  </th>
                  <th className="py-3 px-4 text-end text-sm md:text-base ">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {data ? (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td className="py-3 px-4 w-[120px]">
                      <div className="flex">
                        {data?.image && data.image.length > 0 ? (
                          data.image.map((img, index) => (
                            <Image
                              key={index}
                              src={img || "/placeholder.jpg"}
                              height={70}
                              width={70}
                              className="object-contain"
                              alt="image"
                            />
                          ))
                        ) : (
                          <Image
                            src="/placeholder.jpg"
                            height={70}
                            width={70}
                            className="object-contain"
                            alt="image"
                          />
                        )}
                      </div>
                    </td>
                    <td className="py-3 px-4 text-center">
                      {data?.heading || "—"}
                    </td>
                    <td className="py-3 px-4 text-center">
                      {data?.subtext || "—"}
                    </td>
                    <td className="py-3 px-4 h-full text-primary">
                      <div className="flex items-center justify-end gap-4 h-full">
                        <EditOutlined
                          onClick={() => setIsEditing(true)}
                          className="cursor-pointer hover:text-blue-600 text-[20px]"
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td colSpan={4} className="text-center py-6 text-gray-500 ">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="sm:hidden">
            {data ? (
              <div className="bg-[#F9F9F9] border border-gray-200 rounded-lg p-4 shadow-sm space-y-3">
                <div>
                  <span className="font-semibold text-primary block mb-1">
                    Image:
                  </span>
                  <div className="flex gap-2">
                    {data?.image && data.image.length > 0 ? (
                      data.image.map((img, index) => (
                        <Image
                          key={index}
                          src={img || "/placeholder.jpg"}
                          height={70}
                          width={70}
                          className="object-contain"
                          alt="image"
                        />
                      ))
                    ) : (
                      <Image
                        src="/placeholder.jpg"
                        height={70}
                        width={70}
                        className="object-contain"
                        alt="image"
                      />
                    )}
                  </div>
                </div>

                <div>
                  <span className="font-semibold text-primary block mb-1">
                    Heading:
                  </span>
                  <p>{data?.heading || "—"}</p>
                </div>

                <div>
                  <span className="font-semibold text-primary block mb-1">
                    Subtext:
                  </span>
                  <p>{data?.subtext || "—"}</p>
                </div>

                <div className="">
                  <span className="font-semibold text-primary block mb-1">
                    Action:
                  </span>
                  <EditOutlined
                    onClick={() => setIsEditing(true)}
                    className="cursor-pointer text-black text-[18px]"
                  />
                </div>
              </div>
            ) : (
              <div className="bg-[#F9F9F9] border flex justify-center border-gray-200 rounded-lg p-4 shadow-sm space-y-3">
                <Button type="dashed" onClick={() => setIsEditing(true)}>
                  {" "}
                  Add Data
                </Button>
              </div>
            )}
          </div>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-4 md:p-6 rounded-lg md:rounded-2xl shadow-sm">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Heading"
                name={["experience_tqp", "heading"]}
                rules={[{ required: true, message: "Please enter heading" }]}
              >
                <Input placeholder="Enter heading" />
              </Form.Item>

              <Form.Item
                label="Subtext"
                name={["experience_tqp", "subtext"]}
                rules={[{ required: true, message: "Please enter subtext" }]}
              >
                <TextArea rows={2} placeholder="Enter subtext" />
              </Form.Item>

              <Form.Item
                label="Image"
                name={["experience_tqp", "image"]}
                rules={[{ required: true, message: "Please upload image" }]}
              >
                <UploadFoodImage maxUploadCount={3} bannerAspect={3 / 1} />
              </Form.Item>
            </Form>
          </div>

          <div className="flex justify-start gap-3 mt-6 sticky bottom-5">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExperienceTotalQuality;
